// extracted by mini-css-extract-plugin
module.exports = {"logo":"SignInPage_logo__32gVE","lightTheme":"SignInPage_lightTheme__2Gb3O","darkTheme":"SignInPage_darkTheme__1aWtU","ctaButton":"SignInPage_ctaButton__1nM0E"};